<template>
    <div class="spinner">
        <div :class="`border-${borderWidth}`" class="spinner__node" />
        <div :class="`border-${borderWidth}`" class="spinner__node" />
        <div :class="`border-${borderWidth}`" class="spinner__node" />
        <div :class="`border-${borderWidth}`" class="spinner__node" />
    </div>
</template>

<script>
    export default {
        name: 'LoadingSpinner',
        props: {
            borderWidth: {
                type: Number,
                default: 8,
                validator: (value) => [2, 4, 8].includes(value)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .spinner {
        position: relative;
        height: 26px;
        width: 26px;
        display: inline-block;

        &__node {
            animation: spinner-animation 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            display: block;
            position: absolute;
            border: 2px solid transparent;
            border-top-color: #333;
            border-radius: 50%;
            width: 100%;
            height: 100%;

            &:nth-child(1) {
                animation-delay: -0.45s;
            }

            &:nth-child(2) {
                animation-delay: -0.3s;
            }

            &:nth-child(3) {
                animation-delay: -0.15s;
            }
        }
    }

    @keyframes spinner-animation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
